export default __webpack_public_path__ + "static/media/Homescreen-04.473daa9c.jpg";